module.exports = __webpack_public_path__ + "e07058a7ed9542bee21b18874066bde6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/icons/standards-gray.png
// module id = 1108
// module chunks = 0